import { gql } from "apollo-boost";

const UPDATE_USER_NAMES = gql`
  mutation UpdateUserNames(
    $email: String!
    $first_name: String!
    $last_name: String!
  ) {
    updateName(email: $email, first_name: $first_name, last_name: $last_name) {
      status
      code
      message
      display_message
    }
  }
`;

export default UPDATE_USER_NAMES;
